import i18n from '@/locales/i18n'

import _ from 'lodash'
import is from 'is_js'

export default {
	name : 'data-validator',
	data () {
		return {}
	},
	methods : {
		validate (data) {

			for( var i in data ){

				var field = data[i]

				if(_.has(field, 'disabled') && field.disabled) continue;

				if( field.filters.type == 'string' ){

					if( field.filters.required ){

						if( is.empty( field.value ) ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.required' ).replace( '%name%', field.name )]
							}

							return response

						}

					}

					if( field.filters.minLength ){

						if( _.size(field.value) < field.filters.minLength && !is.empty( field.value ) ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.min_length' ).replace( '%name%', field.name ).replace( '%length%', field.filters.minLength )]
							}

							return response

						}

					}

					if( field.filters.maxLength ){

						if( _.size(field.value) > field.filters.maxLength && !is.empty( field.value ) ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.max_length' ).replace( '%name%', field.name ).replace( '%length%', field.filters.maxLength )]
							}

							return response

						}

					}

					if( field.filters.enum ){

						if( !is.inArray( field.value, field.filters.enum ) && !is.empty( field.value ) ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.invalid_option' ).replace( '%name%', field.name )]
							}

							return response

						}

					}

					if( !is.string( field.value ) && !is.empty( field.value ) ){

						var response = {
							success : false,
							field   : field,
							message : [i18n.t( 'data_validator.type' ).replace( '%name%', field.name )]
						}

						return response

					}

				}

				if( field.filters.type == 'boolean' ){

					if( field.filters.required ){

						if( is.empty( field.value ) ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.required' ).replace( '%name%', field.name )]
							}

							return response

						}

					}

					if( !is.boolean( field.value ) && !is.empty( field.value ) ){

						var response = {
							success : false,
							field   : field,
							message : [i18n.t( 'data_validator.type' ).replace( '%name%', field.name )]
						}

						return response

					}

				}

				if( field.filters.type == 'email'){

					if( field.filters.required ){

						if( is.empty( field.value ) || _.isUndefined(field.value) ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.required' ).replace( '%name%', field.name )]
							}

              return response

						}

					}

					if( field.filters.minLength ){

						if( _.size(field.value) < field.filters.minLength && !is.empty( field.value ) && !_.isUndefined( field.value ) ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.min_length' ).replace( '%name%', field.name ).replace( '%length%', field.filters.minLength )]
							}

							return response

						}

					}

					if( field.filters.maxLength ){

						if( _.size(field.value) > field.filters.maxLength && !is.empty( field.value ) && !_.isUndefined( field.value ) ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.max_length' ).replace( '%name%', field.name ).replace( '%length%', field.filters.maxLength )]
							}

							return response

						}

					}

					if( (!_.isUndefined( field.value ) && field.value != '') && !is.email( field.value )){

						var response = {
							success : false,
							field   : field,
							message : [i18n.t( 'data_validator.type' ).replace( '%name%', field.name )]
						}

						return response

					}

				}

				if( field.filters.type == 'number' ){

					if( field.filters.required ){

						if( is.empty( field.value ) ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.required' ).replace( '%name%', field.name )]
							}

							return response

						}

					}

					if( !is.empty( field.value ) && !is.number( field.value * 1 ) ){

						var response = {
							success : false,
							field   : field,
							message : [i18n.t( 'data_validator.type' ).replace( '%name%', field.name )]
						}

						return response

					}

					if( field.filters.smallerThan ){

						if( field.value < field.filters.smallerThan && !is.empty( field.value ) ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.numeric.smaller_than' ).replace( '%name%', field.name ).replace( '%number%', field.filters.smallerThan )]
							}

							return response

						}

					}

					if( field.filters.greatherThan && !is.empty( field.value ) ){

						if( field.value > field.filters.greatherThan ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.numeric.greather_than' ).replace( '%name%', field.name ).replace( '%number%', field.filters.greatherThan )]
							}

							return response

						}

					}

				}

				if( field.filters.type == 'url' ){

					if( field.filters.required ){

						if( is.empty( field.value ) ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.required' ).replace( '%name%', field.name )]
							}

							return response

						}

					}

					if( !is.url( field.value ) && !is.empty( field.value ) ){

						var response = {
							success : false,
							field   : field,
							message : [i18n.t( 'data_validator.type' ).replace( '%name%', field.name )]
						}

						return response

					}

				}

				if( field.filters.type == 'date' ){

					if( field.filters.required ){

						if( is.empty( field.value ) ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.required' ).replace( '%name%', field.name )]
							}

							return response

						}

					}

					if( !is.date( new Date( field.value ) ) && !is.empty( field.value ) ){

						var response = {
							success : false,
							field   : field,
							message : [i18n.t( 'data_validator.type' ).replace( '%name%', field.name )]
						}

						return response

					}

					if( field.filters.smallerThan ){

						if( new Date( field.value ) < new Date( field.filters.smallerThan ) && !is.empty( field.value ) ){

							var response = {
								success : false,
								key : i,
								message : [i18n.t( 'data_validator.date.smaller_than' ).replace( '%name%', field.name )]
							}

							return response

						}

					}

					if( field.filters.greatherThan ){

						if( new Date( field.value ) > new Date( field.filters.greatherThan ) && !is.empty( field.value ) ){

							var response = {
								success : false,
								key : i,
								message : [i18n.t( 'data_validator.date.greather_than' ).replace( '%name%', field.name )]
							}

							return response

						}

					}

				}

				if( field.filters.type == 'array' ){

					if( field.filters.required ){

						if( _.size(field.value) == 0 ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.required' ).replace( '%name%', field.name )]
							}

							return response

						}

					}

					if( !is.array( field.value ) && !is.empty( field.value ) ){

						var response = {
							success : false,
							field   : field,
							message : [i18n.t( 'data_validator.type' ).replace( '%name%', field.name )]
						}

						return response

					}

					if( field.filters.enum ){

						if( !is.inArray( field.value, field.filters.enum ) && !is.empty( field.value ) ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.invalid_option' ).replace( '%name%', field.name )]
							}

							return response

						}

					}

				}

				if( field.filters.type == 'file' ){

					if( field.filters.required ){

						if( !_.has(field.value, 'data') ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.required' ).replace( '%name%', field.name )]
							}

							return response

						}

					}

					if( _.has(field.value, 'data') ){

						if( field.filters.maxSize ){

							if( field.value.size > field.filters.maxSize ){

								var response = {
									success : false,
									field   : field,
									message : [i18n.t( 'data_validator.file.size' ).replace( '%size%', field.filters.maxSize )]
								}

								return response

							}

						}

						if( field.filters.formatsAllowed ){

							if( !_.includes( field.filters.formatsAllowed, field.value.format ) ){

								var response = {
									success : false,
									field   : field,
									message : [i18n.t( 'data_validator.file.format' ).replace( '%formats%', field.filters.formatsAllowed.join(', ') )]
								}

								return response

							}

						}

					}

				}

				if( field.filters.type == 'manyFields' ){

					for( var j = 0; j < _.size(field.value); j++ ){

						var datoToValidate = {
							field : field.value[j]
						}

						var success = true;

						validate(datoToValidate, function(response){

							if( !response.success ){

								success = false;

								return response

							}

						});

						if( !success ){

							return

						}

					}

				}

				if( field.filters.type == 'manyOptions' ){

					for( var j in field.value ){

						var option = field.value[j];

						if( !is.boolean( option ) && !is.empty( option ) ){

							var response = {
								success : false,
								field   : field,
								message : [i18n.t( 'data_validator.type' ).replace( '%name%', field.name )]
							}

							return response

						}

						if( field.filters.enum ){

							if( !is.inArray( j, field.filters.enum ) ){

								var response = {
									success : false,
									field   : field,
									message : [i18n.t( 'data_validator.invalid_option' ).replace( '%name%', field.name )]
								}

								return response

							}

						}

					}

				}

			}

			var response = {
				success : true
			}

			return response;

		}
	},
	created () {

		let vm = this

		vm.$root.$on('validate', (data) => {

			let dataToValidate = data[0]
			let cb = data[1]

			cb( vm.validate(dataToValidate) )

		})

	}
}



// WEBPACK FOOTER //
// ./src/components/general/data-validator/script.js